import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Credenciales } from '../models/Login';
import { environment } from 'src/environments/environment';
import { IGenericResponse } from '../models/IGenericResponse';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  private http = inject(HttpClient);
  private url = environment.api;

  constructor(private cookieService: CookieService) { }

  loggearUsuario(credenciales: Credenciales) {
    return this.http.post<IGenericResponse>(this.url + "/login/iniciarSesion", credenciales); 
  }
  saveToken(token: string): void {
    this.cookieService.set('authToken', token, { expires: 1, secure: true, sameSite: 'Strict', path: '/' });
  }

  getToken(): string {
    return this.cookieService.get('authToken');
  }

  deleteToken(): void {
    this.cookieService.delete('authToken', '/');
  }
  tokenExpirado(token: string): boolean {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const now = Math.floor(Date.now() / 1000);
    return payload.exp < now;
  }
}